import classNames from "classnames";
import { components, GroupBase, PlaceholderProps } from "react-select";

import styles from "./style.module.scss";

export function Placeholder<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
({ className, children, ...props }: PlaceholderProps<Option, IsMulti, Group>) {
  return (
    <components.Placeholder {...props} className={classNames(className, styles.root)}>
      {children}
    </components.Placeholder>
  );
}